import React, { useContext, useEffect, useState } from "react";

import axios from "axios";
import { store } from "./lib/store";
import CustomerInformationForm from "./library/components/CustomerInformationForm/CustomerInformationForm";
import SpinLoader from "./library/components/spinner/spinner";

import 'antd/dist/antd.css';
import './App.css';
import { getAjaxUrl } from './lib/helpers';

function App() {
  const { state, dispatch } = useContext(store);
  const [two_day_stock, setTwoDayStock] = useState(0);

  const setServiceDays = (val) => {
    dispatch({ type: "updateServiceType", value: val });
  };

  useEffect(() => {
    // submit
    if (state.serviceType === "2 days") {
      const data = new FormData();
      data.append("serviceType", state.serviceType);
      data.append("action", "mnt_get_2_day_service_pending_stock");

      axios
        .post(getAjaxUrl(), data)
        .then((res) => {
          if (res.data && res.data.message && res.data.message === "success") {
            console.log(res.data.pending_qty);
            setTwoDayStock(res.data.pending_qty);
          }
        })
        .catch((err) => console.log(err));
    } else {
      setTwoDayStock(0);
    }
  }, [state.serviceType]);

  useEffect(() => {
    dispatch({type: 'updateCardLimit', value: two_day_stock});
  }, [dispatch, two_day_stock]);

  return (
    <div className={`mnt-payment-form ${state.loading ? "loading" : ""}`}>
      {state.loading && <SpinLoader />}

      <h4>Select Service Days :</h4>
      <div className="serviceDays-container">
        <div
          className={`serviceDay ${
            state.serviceType === "2 days" ? "selected" : ""
          }`}
          onClick={() => setServiceDays("2 days")}
        >
          <img
            src="https://mntgrading.com/wp-content/uploads/2022/02/first-class-service-134x90.png"
            width="134"
            height="90"
            alt="first-class-service"
            title="first-class-service"
          />
          <div className="title">2 Days</div>
        </div>
        <div
          className={`dealer-only serviceDay ${
            state.serviceType === "2 weeks" ? "selected" : ""
          }`}
          onClick={() => setServiceDays("2 weeks")}
        >
          <img
            src="https://mntgrading.com/wp-content/uploads/2022/02/priority-service-134x90.png"
            width="134"
            height="90"
            alt="priority-service"
            title="priority-service"
          />
          <div className="title">2 Weeks</div>
        </div>
        <div
          className={`serviceDay ${
            state.serviceType === "1 month" ? "selected" : ""
          }`}
          onClick={() => setServiceDays("1 month")}
        >
          <img
            src="https://mntgrading.com/wp-content/uploads/2022/02/rush-service-90x90.png"
            width="90"
            height="90"
            alt="rush-service"
            title="rush-service"
          />
          <div className="title">1 Month</div>
        </div>
        <div
          className={`serviceDay ${
            state.serviceType === "3 months" ? "selected" : ""
          }`}
          onClick={() => setServiceDays("3 months")}
        >
          <img
            src="https://mntgrading.com/wp-content/uploads/2022/02/standard-service-90x90.png"
            width="90"
            height="90"
            alt="standard-service"
            title="standard-service"
          />
          <div className="title">3 Months</div>
        </div>
        {/* <div
          className={`serviceDay ${
            state.serviceType === "6 months" ? "selected" : ""
          }`}
          onClick={() => setServiceDays("6 months")}
        >
          <img
            src="https://mntgrading.com/wp-content/uploads/2022/02/value-service-90x90.png"
            width="90"
            height="90"
            alt="value-service"
            title="value-service"
          />
          <div className="title">6 Months</div>
        </div> */}
      </div>

      <h4>Card Details</h4>
      <CustomerInformationForm />
    </div>
  );
}

export default App;
